import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";
import {$accountsFactory} from "../../$accounts.factory";
import {AccountModel} from "../../angular/models/account.model";
import {AccountRequests} from "../../services/account-requests.service";

export class demandAccountsMultiSelectCtrl implements IController {

  accounts: AccountModel[];
  selectedIds: any;
  branchIds: any[];
  options: any;
  optionIds: any;
  ngPlaceholder: any;
  excludeIds: any;
  isDisabled: any;
  isRequired: boolean;
  onChange: Function;

  private accountsRef: any;
  public selectedAccounts: any;
  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $accounts: $accountsFactory, private $element,
              private accountRequests: AccountRequests) {
    this.accountsRef = this.$accounts();
  }

  $onInit() {
    this._setSelectedAccounts();
  };

  $onChanges(changes) {
    if (changes.serviceAreas && !changes.serviceAreas.isFirstChange()) {
      this._setSelectedAccounts();
    }
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this._setSelectedAccounts();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdsRef = (this.selectedIds ? this.selectedIds : (!!this.accounts ? _.map(this.accounts, 'id') : []));
    const branchIdsRef = this.branchIds;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;
    const ngPlaceholderRef = this.ngPlaceholder;
    const excludeIdsRef = this.excludeIds;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-multi-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-ids="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'service-areas-types="ctrl.serviceTypesRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-multi-select-filter-panel>',
      controller: function () {
        this.typeRef = 'accounts';
        this.selectedIdsRef = selectedIdsRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.excludeIdsRef = excludeIdsRef;
        this.queryMapRef = {
          branchIds: branchIdsRef,
        };
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedIds) => {
        if (selectedIds === 'clickOutsideToClose' || selectedIds === 'escapeToClose') {
          selectedIds = selectedIdsRef;
        }

        this.onChange({accounts: [], ids: selectedIds || []});
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({ids: [], accounts: []});
  }

  private _setSelectedAccounts() {
    if (!!this.accounts) {
      this.selectedAccounts = angular.copy(this.accounts);
    } else if (!!this.selectedIds) {
      if (!!this.options) {
        this.selectedAccounts = _.filter(this.options, (o) => {
          return _.includes(this.selectedIds, o.id);
        });
        this._setSelectedText();
      } else {
        this._queryAccountsByIds(this.selectedIds)
          .then((accounts) => {
            this.selectedAccounts = _.orderBy(accounts, ['name'], ['asc']);
            this._setSelectedText();
          })
      }
    } else {
      this.selectedAccounts = [];
      this._setSelectedText();
    }

  }

  private _queryAccountsByIds(ids: string[]): angular.IPromise<AccountModel[]> {
    return this.accountRequests.queryAccounts({ids}).then((response) => response.list);
  }

  private _setSelectedText() {
    let string = '';
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext("2d");

    _.forEach(this.selectedAccounts, (b, i) => {
      string += b.name;
      if ((i + 1) < this.selectedAccounts.length) {
        string += ', '
      }
    });

    var stringWidth = ctx.measureText(string).width;
    if (this.$element[0]?.clientWidth && (stringWidth + 80) >= (this.$element[0].clientWidth - 30)) {
      string = this.selectedAccounts[0].name + ` +${this.selectedAccounts.length - 1}`
    }
    this.selectedText = string;
  }


}

angular
  .module('bringoz.admin.accounts')
  .component('demandAccountsMultiSelect', {
    bindings: {
      accounts: '<?',
      selectedIds: '<?',
      branchIds: '<?',
      options: '<?',
      optionIds: '<?',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      isDisabled: '<?',
      isRequired: '<?',
      onChange: '&'
    },
    template: require('./demand-accounts-multi-select.html').default,
    controller: demandAccountsMultiSelectCtrl
  });
